var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ba06cfac-593f-419f-b2a1-3894f5789725",
    "data-name": "Path",
    d: "M59.49,116.47H43a6.18,6.18,0,0,1-6.17-6.18V69.81a6.17,6.17,0,0,0-6.17-6.17H25.85A6.18,6.18,0,0,1,21.57,53L52.41,23.27c7.42-6.27,14.46-3.51,18.24-.39L101.18,53a6.17,6.17,0,0,1-4.27,10.63H92.08a6.17,6.17,0,0,0-6.17,6.17v40.48a6.18,6.18,0,0,1-6.18,6.18Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fa35e84a-dd4b-48ba-add8-9e299d0ffabf",
    "data-name": "Path",
    d: "M129.39,76.28H113.22a6.06,6.06,0,0,0-6.06,6.07V122.1a6.07,6.07,0,0,1-6.07,6.06H96.36a6.07,6.07,0,0,0-4.2,10.44l30.28,29.19c7.28,6.17,14.19,3.45,17.91.39l30-29.58a6.07,6.07,0,0,0-4.2-10.44h-4.74a6.06,6.06,0,0,1-6.06-6.06V76.28Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSystem);
export default __webpack_public_path__ + "static/media/data-system.0b0d93a9bf9fb0c132af7c6c23611d76.svg";
export { ForwardRef as ReactComponent };